export const RETRY_MAX_COUNT = 3;
export const RETRY_DELAY = 500;

export const ApiRoutes = {
  auth: {
    check: "/users/check",
    exid: "/users/exid",
    login: "/auth/login",
    logout: "/auth/logout",
    mail_change: "/users/mail",
    mail_change_send: "/users/mail/send",
    mail_check: "/users/check",
    membership: "/users/membership",
    password_change: "/password",
    password_reminder: "/password/reminder",
    quit: "/users/quit",
    register: "/users/register",
    register_mail: "/users/register/mail",
    temporary: "/users/temporary",
    temporary_mail: "/users/temporary/mail",
    user: "/users",
    user_edit: "/users",
  },
  banner: {
    search: "/banners/search",
  },
  campaign: {
    active: "/campaigns/search/active", // 変更：早割専用から汎用APIへ
  },
  coupon: {
    check: "/coupons/check",
    external: "/coupons/external",
    limited: "/coupons/limited",
    search: "/coupons/search",
    validate: "/coupons/validate",
    redeem: "/coupons/redeem",
  },
  menu: {
    like: "/menus/like",
    limited: "/menus/limited",
    search: "/menus/search",
    stock: "/limited-stock/menus", // 追加：在庫販売メニュー取得
  },
  order: {
    create: "/orders",
    finalize: "/orders/finalize",
    search: "/orders/search",
    status: "/orders/{order_id}/status",
    temporary: "/orders/temporary",
    temporary_release_stock: "/orders/temporary/release-stock",
    update: "/orders",
  },
  payment: {
    url: "/payments/url",
  },
  recaptcha: {
    check: "/recaptcha_check?recaptchaToken={recaptchaToken}",
  },
  store: {
    like: "/stores/like",
    search: "/stores/search",
  },
  twilio: {
    check: "/VerificationCheck",
    send: "/Verifications",
  },
};
